import React, { useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import * as routerSelectors from 'app/selectors/router';
import { capitalize } from 'lodash';
import FailureState from 'app/components/customer/dashboard/FailureState';
import { AvailableProducts, MultiMonthPlanMapping, UserSelectedSubProductMapping } from 'app/constants/Products';
import Step2 from './Step2';
import NameStep from '../Parts/Step3';
import StepMultimonthPlanSelection from './StepMultimonthPlanSelection';
import { KingV2SubProducts } from 'app/constants/Products';
import DrawerMenu from 'app/components/common/DrawerMenu';
import { Drawer, NavBar, PageWrapper } from 'mui';
import LoginType from 'app/components/customer/Registration/Parts/LoginType';

const mapStateToProps = (state) => {
  const router = routerSelectors.selectRouterQuery(state);
  const feedbackParam = router.get('registration_feedback');
  const testMode = router.get('test_mode');
  const subProduct = (() => {
    const sub_product = router.get('sub_product');

    return Object.keys(UserSelectedSubProductMapping).find((key) =>
      UserSelectedSubProductMapping[key].includes(sub_product),
    );
  })();
  const currentPlan = (() => {
    const plan = router.get('plan');
    const capitalizedPlan = capitalize(plan);

    const planKey = Object.keys(MultiMonthPlanMapping).find((key) => MultiMonthPlanMapping[key] === capitalizedPlan);

    return planKey ? parseInt(planKey, 10) : null;
  })();
  const cpn = router.get('cpn'); // king free labs experiment
  const aep = router.get('aep'); // king pricing experiment
  const bep = router.get('bep'); // lover pricing experiment
  const wep = router.get('wep'); // magician pricing experiment
  const tfid = router.get('tfid'); // king first installment discount experiment

  return {
    feedbackParam,
    initialValues: {
      settings: {
        product: AvailableProducts.King,
        test_mode: testMode,
        sub_product: subProduct,
        multimonth_plan: currentPlan,
        cpn: cpn,
        aep,
        bep,
        wep,
        tfid,
      },
      step0: {
        state: '',
        pc_opt_in: false,
        mso_opt_in: false,
        over_18: false,
      },
      step1: {
        first_name: '',
        last_name: '',
      },
      step2: {
        email: window.emailFromTypeform,
        password: '',
        password_confirmation: '',
      },
    },
  };
};

const KingRegistration = ({ feedbackParam, initialValues, experimentVariant }) => {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const [allValues, setAllValues] = useState(initialValues);
  const [currentStep, setCurrentStep] = useState(0);
  const stepValue = allValues[`step${currentStep}`];
  const [planSelected, setPlanSelected] = useState(false);

  const onSubmitNextStep = useCallback(
    (values) => {
      setAllValues((allValues) => ({
        ...allValues,
        [`step${currentStep}`]: values,
      }));
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    },
    [currentStep],
  );

  const handleChangeProduct = (params: any) => {
    setAllValues((allValues) => ({
      ...allValues,
      ['settings']: {
        ...allValues.settings,
        multimonth_plan: params.multimonth_plan,
        sub_product: KingV2SubProducts.Enclo,
      },
    }));
    setPlanSelected(true);
  };

  const initialValuesMultimonthPlan = {
    multimonth_plan: allValues.settings?.multimonth_plan || 12,
    selected_king_v2_product: KingV2SubProducts.Enclo,
  };

  const isValidState = window.kingV2AvailableStates.includes(allValues.step0?.state);
  const isOralTrt = [
    KingV2SubProducts.OralTrt,
    KingV2SubProducts.EncloTrt,
    KingV2SubProducts.Topical,
    KingV2SubProducts.EncloTopical,
    KingV2SubProducts.Injectable,
    KingV2SubProducts.InjectableHCG,
    KingV2SubProducts.EncloInjectable,
  ].includes(allValues.settings?.sub_product);
  const showPlanSelection = !planSelected && isOralTrt && !isValidState;

  const content = useMemo(
    () => (
      <>
        {currentStep === 0 && (
          <Step2 initialValues={stepValue} onSubmit={onSubmitNextStep} experimentVariant={experimentVariant} />
        )}
        {currentStep === 1 && showPlanSelection && (
          <StepMultimonthPlanSelection onSubmit={handleChangeProduct} initialValues={initialValuesMultimonthPlan} />
        )}
        {currentStep === 1 && !showPlanSelection && (
          <NameStep initialValues={stepValue} onSubmit={onSubmitNextStep} trackSegmentEvent={true} />
        )}
        {currentStep === 2 && <LoginType allValues={allValues} trackSegmentEvent />}
      </>
    ),
    [currentStep, stepValue, allValues.step0, onSubmitNextStep, experimentVariant],
  );

  if (feedbackParam) {
    return (
      <Drawer sideContent={<DrawerMenu loggedIn={false} />}>
        <NavBar />
        <FailureState state={feedbackParam} />
      </Drawer>
    );
  }

  return <PageWrapper>{content}</PageWrapper>;
};

export default connect(mapStateToProps)(KingRegistration);
